import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { PERMISSIONS } from 'constants/permissions';
import { ADMIN_ROUTES } from 'constants/routes';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.items.suppliers,
        label: 'Suppliers',
        permission: PERMISSIONS.items.tabs.suppliers.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.items.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.items.tabs.task.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.items.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.items.tabs.attachment.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.items.logs,
        label: 'Logs',
        permission: PERMISSIONS.items.tabs.logs.read,
        id: '4',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
